import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer, CardContent, Button, CircularProgress, Box, FormControlLabel, Checkbox,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import {useGetSemestersQuery} from "../store/system/systemApi";
import MenuItem from "@mui/material/MenuItem";
import FormGroup from "@mui/material/FormGroup";
import PrintIcon from "@mui/icons-material/Print";

export default function ResidualKnowledgeMonitoringWebReportPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const data = null;
    const {data: semestersData, isLoading: isLoadingSemesters} = useGetSemestersQuery();
    const [selectedSemester, setSelectedSemester] = useState(null);
    const [enableIntramural, setEnableIntramural] = useState(true);
    const [enableExtramural, setEnableExtramural] = useState(true);
    const [enableIntramuralExtramural, setEnableIntramuralExtramural] = useState(true);
    
    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const handleSave = async () => {
        downloadReport();
    };

    function downloadReport() {
        setIsLoading(true);
        fetch(`/Reports/ResidualKnowledgeMonitoringPrintableReport?semesterId=${selectedSemester}&enableIntramural=${enableIntramural}&enableExtramural=${enableExtramural}&enableIntramuralExtramural=${enableIntramuralExtramural}&fileType=xlsx`,
            {
                method: "GET",
                headers: {
                    "semesterid": localStorage.getItem("selectedSemesterId"),
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('token')}`
                }
            }).then(response => {
            setIsLoading(false);
            return response.blob();
        }).then(response => {
            if (response.size === 0) {
                alert('Не удалось загрузить файл')
                return;
            }

            const url = window.URL.createObjectURL(
                new Blob([response]),
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `Мониторинг остаточных знаний.xlsx`,
            );

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
        }).catch((e) => {
            alert('Ошибка')
        })
    }

    return (
        <GeneralLayout>
            <PageTitle title={`Мониторинг остаточных знаний`} />

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            {isLoadingSemesters ? <CircularProgress /> : <></>}
                            Мониторинг остаточных знаний
                        </Typography>
                    </Stack>

                    <Card>
                        <CardContent>
                            <Stack spacing={2}>
                                <Stack spacing={2} 
                                       direction="row">
                                    <TextField
                                        label="Семестр"
                                        select
                                        size={'small'}
                                        fullWidth   
                                        value={selectedSemester}
                                        onChange={(e) => {setSelectedSemester(e.target.value)}}>
                                        {
                                            semestersData?.data?.map((item) => {
                                                return <MenuItem value={item.key} key={item.key}>{item.value}</MenuItem>
                                            })
                                        }
                                    </TextField>
                                </Stack>

                                <FormGroup>
                                    <FormControlLabel control={<Checkbox checked={enableExtramural} 
                                                                         onChange={(e) => setEnableExtramural(e.target.checked)} />} 
                                                      label="Заочная ф.о." />
                                    <FormControlLabel control={<Checkbox checked={enableIntramural}
                                                                         onChange={(e) => setEnableIntramural(e.target.checked)} />}
                                                                         label="Очная ф.о." />
                                    <FormControlLabel control={<Checkbox checked={enableIntramuralExtramural}
                                                                         onChange={(e) => setEnableIntramuralExtramural(e.target.checked)} />}
                                                                         label="Очно-заочная ф.о." />
                                </FormGroup>

                                <Stack justifyContent="space-between">
                                    {
                                        !isSaving
                                            ? <Button variant="contained"
                                                      startIcon={isLoading ? <CircularProgress size={15}/> : <PrintIcon />}
                                                      disabled={isLoading || !selectedSemester || !enableExtramural && !enableIntramural && !enableIntramuralExtramural}
                                                      onClick={handleSave}>Печать XLSX</Button>
                                            : <CircularProgress/>
                                    }
                                </Stack>
                            </Stack>
                        </CardContent>
                    </Card>

                    <br />
                </Stack>
            </Container>
        </GeneralLayout>
    );
}